/**
 * vue 兄弟组件之间传值
 */
import Vue from 'vue'
const Bus = new Vue()
export default Bus